import { render, staticRenderFns } from "./GerenciarSecoes.vue?vue&type=template&id=58a4f4f0&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarSecoes.vue?vue&type=style&index=0&id=58a4f4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a4f4f0",
  null
  
)

export default component.exports